import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Notification } from '../../models/reusables/notification';

/**
 * This service is a notification store
 *
 * See {@link Notification} for details about the main data of this store
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  readonly notificationSubject$ = new Subject();

  public getNotification() {
    return this.notificationSubject$;
  }

  public showNotification(notification: Notification) {
    this.notificationSubject$.next(notification);
  }
}
